import { fetchAssignments } from '../../services/assignments';
import { fetchBricks } from '../../services/bricks';
import { fetchClientsByStatus } from '../../services/clients';
import { fetchPhases } from '../../services/phases';
import { fetchMembers, fetchProfile, linkProfileToMember } from '../../services/profiles';
import { fetchProfilesPlanning } from '../../services/profilesPlanning';
import { migrateState } from '../../uiPrefs';
import { fetchAllPaginated } from '../../utils/supabaseQuery';
import { groupBy, mapAssignment, mapBrick, mapClient, mapMember, mapPhase } from './dbMappers';

/* Chargement du profil connecté et des données de planning (clients, phases, briques,
   affectations, membres). */
export function createAppDataActions({
  profile,
  setAppDataLoaded,
  setAuthLoading,
  setProfile,
  setAppState,
}) {
  async function loadProfile(userId) {
    const { data } = await fetchProfile(userId);
    const profileWithDev = { ...data, dev_id: data?.dev_id || userId };
    setProfile(profileWithDev);
    setAuthLoading(false);
    if (!data?.dev_id) linkProfileToMember(userId);
    await loadAppData(data?.role === 'manager');
  }

  // Supabase vide → charger depuis localStorage pour proposer la migration
  function loadLocalData(devs) {
    try {
      const old = localStorage.getItem('pdc3');
      if (!old) return false;
      const p = migrateState(JSON.parse(old));
      setAppState((prev) => ({
        ...prev,
        clients: p.clients || [],
        affectations: p.affectations || [],
        devs: devs.length ? devs : p.devs || [],
        _hasLocalData: true,
      }));
      setAppDataLoaded(true);
      return true;
    } catch (e) {
      return false;
    }
  }

  async function loadAppData(isManagerRole) {
    const managerView = isManagerRole ?? profile?.role === 'manager';
    // Paginé : au-delà de 1000 lignes, Supabase tronque sans erreur (affectations disparues au
    // rechargement, planifié faux).
    const [clientsData, phasesData, bricksData, affectationsData, devsData] = await Promise.all([
      fetchAllPaginated(fetchClientsByStatus()),
      fetchAllPaginated(fetchPhases()),
      fetchAllPaginated(fetchBricks()),
      fetchAllPaginated(fetchAssignments()),
      fetchAllPaginated(managerView ? fetchMembers() : fetchProfilesPlanning()),
    ]);

    const bricksByPhase = groupBy(bricksData, 'phase_id', mapBrick);
    const phasesMap = groupBy(phasesData, 'client_id', (ph) =>
      mapPhase(ph, bricksByPhase[ph.id] || []),
    );
    const clients = (clientsData || []).map((c) => mapClient(c, phasesMap[c.id] || []));
    const affectations = (affectationsData || []).map(mapAssignment);
    const devs = (devsData || []).map(mapMember);

    if (clients.length === 0 && loadLocalData(devs)) return;
    setAppState((prev) => ({ ...prev, clients, affectations, devs, _hasLocalData: false }));
    setAppDataLoaded(true);
  }

  return { loadProfile, loadAppData };
}
